/* istanbul ignore next */
import { IValueAddedServicesSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

export function getVAS(valueAddedServices: IValueAddedServicesSchema | null): EBC.TVas[] {
  if (!valueAddedServices) {
    return [];
  }

  const { isAuction, isColorized, isFree, isPaid, isPremium, isTop3 } = valueAddedServices;

  return [
    isAuction && 'auction',
    isColorized && 'color',
    isFree && 'free',
    isPaid && 'paid',
    isPremium && 'premium',
    isTop3 && 'top3',
  ].filter(Boolean) as EBC.TVas[];
}
